import { Store } from "vuex";
import { IState } from "../models/IState";

export const commitForCreditLine = <T>(
  key: string,
  payload: T,
  store: Store<IState>
): void => {
  store.commit("creditLine/" + key, payload);
};
